export default {
    url: '/add/:occurrenceId?',
    template: `
        <div class="heading02">
            <div class="heading01">
                <h2>{{ 'course.Add occurrence' | translate }}</h2>
            </div>
            <div class="arrow-steps clearfix">
                <div class="step" ng-class="{ current: vm.step==1 }">
                    <span ng-if="vm.step==1">{{ 'course.General data' | translate }}</span>
                    <a ui-sref="authorized.courses.courses.edit.occurrence.add.general({ id: vm.course.id, occurrenceId: vm.occurrence.id })" ng-if="vm.step>1">
                        {{ 'course.General data' | translate }}
                    </a>
                </div>
                <div class="step" ng-class="{ current: vm.step==2 }">
                    <span ng-if="vm.step<=2">{{ 'course.Employees' | translate }}</span>
                    <a ui-sref="authorized.courses.courses.edit.occurrence.add.employee({ id: vm.course.id, occurrenceId: vm.occurrence.id })" ng-if="vm.step>2">
                        {{ 'course.Employees' | translate }}
                    </a>
                </div>
                <div class="step" ng-class="{ current: vm.step==3 }">
                    <span ng-if="vm.step<=4">{{ 'course.Schedule' | translate }}</span>
                    <a ui-sref="authorized.courses.courses.edit.occurrence.add.schedule({ id: vm.course.id, occurrenceId: vm.occurrence.id })" ng-if="vm.step>4">{{ 'course.Schedule' | translate }}</a>
                </div>
            </div>
        </div>
        <ui-view></ui-view>
    `,
    abstract: true,
    params: {
        occurrenceId: { squash: true, value: null }
    },
    controller ($scope, course, rooms, PrivilegeService) {
        this.$scope = $scope;
        this.course = course;
        this.rooms = rooms;
        // todo move occurrence to this state so we can use OccurrenceService.isReadonlyOccurrence
        this.canManageOccurrences = PrivilegeService.canManageOccurrences();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/add/index.js